import type {
  NewsletterSamplePollItem,
  NewsletterSampleResponse,
  NewsletterSampleTriviaItem,
} from '@/lib/services/newsletterSampleGeneration';
import type { NewsletterEmailQuestionData } from './NewsletterEmailQuestion';

export const DEMO_QUIZ_SLUG = 'newsletter-engagement-demo';
export const DEMO_QUIZ_TITLE = 'Atrivial Overview Demo';

export const DEFAULT_PASTED_CONTENT = [
  'Open rates show that someone opened your newsletter. They do not show which ideas landed.',
  'Polls and Quiz answers add a richer signal. Readers intentionally share their preferences, interests, and knowledge, often called zero-party data. Response patterns can guide future coverage, sharpen audience segments, and help sponsors understand what readers care about.',
].join('\n\n');

export const DEMO_SAMPLE: NewsletterSampleResponse & {
  items: [NewsletterSampleTriviaItem, NewsletterSampleTriviaItem, NewsletterSamplePollItem];
} = {
  sampleId: DEMO_QUIZ_SLUG,
  sourceSummary:
    'Pre-created demo Quiz about audience insights newsletter operators can learn from polls and Quiz responses.',
  warnings: [],
  items: [
    {
      type: 'trivia',
      stem: 'What kind of data do readers intentionally share through polls?',
      answers: ['Zero-party data', 'Third-party data', 'Device metadata', 'Modeled data'],
      correctAnswerIndex: 0,
      fact: 'Zero-party data comes directly from readers and can reveal their preferences without behavioral tracking.',
      sourceUrl: 'https://atrivial.com/',
    },
    {
      type: 'trivia',
      stem: 'What can Quiz answers reveal that open rates cannot?',
      answers: ['Reader interests and knowledge', 'Inbox placement', 'List size', 'Delivery time'],
      correctAnswerIndex: 0,
      fact: 'Response patterns show which topics resonate. This is useful for editorial planning and sponsor targeting.',
      sourceUrl: 'https://atrivial.com/',
    },
    {
      type: 'poll',
      prompt: 'How will Atrivial benefit your newsletter?',
      options: [
        'New sponsor slot to increase revenue',
        'Retain readers with gamification',
        'Automate content creation',
        'Something else',
      ],
      sourceUrl: 'https://atrivial.com/',
    },
  ],
};

const firstTrivia = DEMO_SAMPLE.items[0];
const distractors = firstTrivia.answers.filter(
  (_, index) => index !== firstTrivia.correctAnswerIndex
);

export const DEMO_QUESTION: NewsletterEmailQuestionData = {
  question_id: 555501,
  edition_item_id: '55555555-5555-4555-8555-555555555503',
  stem: firstTrivia.stem,
  key: firstTrivia.answers[firstTrivia.correctAnswerIndex],
  distractor_1: distractors[0],
  distractor_2: distractors[1],
  distractor_3: distractors[2],
};
